import { Theme } from "@mui/material/styles";
import { keyframes } from "@emotion/react";

const loaderAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

interface Styles {
  [key: string]: any;
}

export const styles = (theme: Theme): Styles => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    padding: theme.spacing.spacing6,
    textAlign: "center",
  },
  loaderSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing.spacing8,
  },
  loader: {
    position: "relative",
    width: "120px",
    height: "120px",
  },
  loaderBody: {
    position: "absolute",
    left: "20%",
    top: "20%",
    animation: `${loaderAnimation} 1000ms linear infinite`,
  },
  icon: {
    marginBottom: theme.spacing.spacing12_5,
  },
  title: {
    marginBottom: theme.spacing.spacing4,
  },
  description: {
    maxWidth: "600px",
    whiteSpace: "pre-line",
    marginBottom: theme.spacing.spacing8,
  },
  retryButton: {
    minWidth: "240px",
  },
});
